import { createContext, useContext, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';

const NotificationContext = createContext(null);

export function NotificationProvider({ children }) {
  const [snack, setSnack] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const notify = (message, severity = 'success') => {
    setSnack({ open: true, message, severity });
  };

  const handleClose = () => {
    setSnack(s => ({ ...s, open: false }));
  };

  return (
    <NotificationContext.Provider value={{ notify }}>
      {children}

      {/* Global Snackbar */}
      <Snackbar
        open={snack.open}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          variant="filled"
          severity={snack.severity}
          onClose={handleClose}
          sx={{
            backgroundColor:
              snack.severity === 'success'
                ? '#16a34a'
                : snack.severity === 'error'
                ? '#dc2626'
                : snack.severity === 'warning'
                ? '#d97706'
                : '#2563eb'
          }}
        >
          {snack.message}
        </Alert>
      </Snackbar>
    </NotificationContext.Provider>
  );
}

export const useNotify = () => useContext(NotificationContext);
